import { SyncDescriptor } from 'vscode/vscode/vs/platform/instantiation/common/descriptors';
import { BrowserTitleService } from './vscode/src/vs/workbench/browser/parts/titlebar/titlebarPart.js';
import { ITitleService } from 'vscode/vscode/vs/workbench/services/title/browser/titleService.service';
import { registerServiceInitializePostParticipant } from 'vscode/lifecycle';

function getServiceOverride() {
    return {
        [( ITitleService.toString())]: new SyncDescriptor(BrowserTitleService, [], false)
    };
}
registerServiceInitializePostParticipant(async (accessor) => {
    accessor.get(ITitleService);
});

export { getServiceOverride as default };
